export default __webpack_public_path__ + "static/media/crossIcon.7f811b79.svg";